import React, { Component } from 'react';
import { Dialog, DialogContent } from './components/Dialog';
import PrimaryButton from './components/PrimaryButton/PrimaryButton';

export class SignUpValidationErrorMessage extends Component {
  render() {
    return (
      <Dialog
        open={this.props.isShow}
        onOpenChange={(isOpen) => {
          if (!isOpen) {
            this.props.onHide();
          }
        }}
      >
        <DialogContent
          className='w-[min(92vw,44rem)] rounded-[0.8rem] border-0 bg-white text-[1.6rem] shadow-[0_14px_34px_rgba(0,0,0,0.2)]'
          overlayClassName='bg-black/50'
        >
          <div className='ModalDialogText signUpValidationErrorMessage'>
            <p style={{ paddingBottom: '1em' }}>
              There is either incomplete information or a problem with the information being provided.
            </p>
            <p>The problematic areas are highlighted in red. Please correct the problems and try again.</p>
          </div>
          <div style={{ textAlign: 'center', padding: '2em' }}>
            <PrimaryButton small onClick={this.props.onHide}>
              Okay
            </PrimaryButton>
          </div>
        </DialogContent>
      </Dialog>
    );
  }
}
